import React from 'react';
import { LegalPage } from '../components/LegalPage';
import { refundPolicy } from '../data/legal';
export function RefundPolicyPage() {
  return <LegalPage document={refundPolicy} data-id="element-224" data-mp="byrwzmn2csps" />;
}